import * as Types from './Types'
// import * as Storages from '../helpers/Storage'

export function showAlert(
  header,
  text,
  type,
  firstButton = { title: '', onPress: () => {} },
  secondButton = { title: '', onPress: () => {} },
  thirdButton = { title: '', onPress: () => {} }
) {
  return dispatch => {
    dispatch({
      type: Types.SHOW_ALERT,
      payload: {
        header,
        text,
        type,
        firstButton,
        secondButton,
        thirdButton
      }
    })
  }
}

export function hideAlert() {
  return dispatch => {
    dispatch({
      type: Types.HIDE_ALERT
    })
  }
}

export function setLanguage(language) {
  // Storages.setLanguage(language)

  return dispatch => {
    dispatch({
      type: Types.SET_LANGUAGE,
      payload: language
    })
  }
}

export function toggleMenu() {
  return dispatch => {
    dispatch({
      type: Types.TOGGLE_MENU
    })
  }
}

export function showEditEmailModal() {
  return dispatch => {
    dispatch({
      type: Types.SHOW_EDIT_EMAIL_MODAL
    })
  }
}

export function hideEditEmailModal() {
  return dispatch => {
    dispatch({
      type: Types.HIDE_EDIT_EMAIL_MODAL
    })
  }
}

export function showEditPasswordModal(user) {
  return dispatch => {
    dispatch({
      type: Types.SHOW_EDIT_PASSWORD_MODAL
    })
  }
}

export function hideEditPasswordModal() {
  return dispatch => {
    dispatch({
      type: Types.HIDE_EDIT_PASSWORD_MODAL
    })
  }
}

export function showDeleteAccountModal() {
  return dispatch => {
    dispatch({
      type: Types.SHOW_DELETE_ACCOUNT_MODAL
    })
  }
}

export function hideDeleteAccountModal() {
  return dispatch => {
    dispatch({
      type: Types.HIDE_DELETE_ACCOUNT_MODAL
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/Config.js